import React from "react";

import Container from "react-bootstrap/Container";
import { SideBar } from "./sideBar";
import { NavBar } from "./navBar";
import { ListRutines } from "./rutines/listRutines";
import useStoredPermissions from "./useStoredPermissions";

export const MainRutine = () => {
  const permissions = useStoredPermissions() || [];

  const hasPermissions =
    permissions.includes("Super User") ||
    permissions.includes("Read Video") ||
    permissions.includes("Read Routine");

  return (
    <React.Fragment>
      {hasPermissions && <SideBar />}
      <Container>
        <NavBar />
        <Container>
          <ListRutines />
        </Container>
      </Container>
    </React.Fragment>
  );
};
